module.exports = __webpack_public_path__ + "static/img/Liquid Silicone Rubber for Medical.92b0145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Liquid Silicone Rubber for Medical.jpg
// module id = npIc
// module chunks = 1